import { useMemo as commonUseMemo } from "packages/react";

export const useMemo = commonUseMemo;
